import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import { Store } from 'lucide-react';
import { ROUTES } from 'app/javascript/constants/routes';
import { trackEvent } from 'app/javascript/firebase';
import type { StoreProduct } from 'app/javascript/data/storeCatalogs';

// A compact, non-buyable product tile for the company-page teaser. The whole
// card links to the product detail page, where buying happens.
export default function StorePreviewCard({ product, slug }: { product: StoreProduct; slug: string }) {
  const [imageBroken, setImageBroken] = useState(false);

  return (
    <Link
      to={ROUTES.COMPANY_STORE_PRODUCT}
      params={{ slug, productId: product.id }}
      onClick={() => trackEvent('store_preview_clicked', { company_slug: slug, target: product.id })}
      className="group flex flex-col overflow-hidden rounded-2xl border border-slate-700/50 bg-slate-800/50 backdrop-blur-sm transition-colors hover:border-yellow-400/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-yellow-400/50"
    >
      <div className="relative aspect-square overflow-hidden bg-slate-900">
        {imageBroken ? (
          <div className="flex h-full w-full items-center justify-center text-slate-600">
            <Store className="size-10" aria-hidden />
          </div>
        ) : (
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            onError={() => setImageBroken(true)}
            className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.03]"
          />
        )}
      </div>
      <div className="p-4">
        <h3 className="font-bebas text-lg uppercase leading-tight tracking-wide text-foreground transition-colors group-hover:text-yellow-400">
          {product.name}
        </h3>
        {product.variant && <p className="mt-0.5 text-xs text-slate-400">{product.variant}</p>}
      </div>
    </Link>
  );
}
